import React from 'react';
import { WarningCircle, XCircle } from '@phosphor-icons/react';
import { formatMB } from '../../../shared/utils/fileFormat.js';

const PlanStorageWarningBanner = ({ storage }) => {
  if (storage.percentage < 80) {
    return null;
  }

  const isLimitReached = storage.percentage >= 100;
  const free = Math.max(storage.free, 0);

  return (
    <div
      className={`mt-4 flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium border ${
        isLimitReached
          ? 'bg-error/12 border-error/30 text-error'
          : 'bg-warning/12 border-warning/30 text-warning'
      }`}
    >
      {isLimitReached ? <XCircle size={18} /> : <WarningCircle size={18} />}
      {isLimitReached
        ? `Alcanzaste el límite de almacenamiento de tu plan (${formatMB(storage.limit)}). Libera espacio o gestiona una ampliación de plan.`
        : `Quedan ${formatMB(free)} disponibles de tu plan. Te estás acercando al límite contratado.`}
    </div>
  );
};

export default PlanStorageWarningBanner;
